import API from "../axiosConfig";

export const getZones = async () => {
  try {
    const response = await API.get("/zones");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getZoneById = async (id) => {
  try {
    const response = await API.get(`/zones/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createZone = async (payload) => {
  try {
    const response = await API.post("/zones", { ...payload });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteZoneApi = async (id) => {
  try {
    const response = await API.delete(`/zones/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateZone = async (zoneId, data) => {
  try {
    const response = await API.put(`/zones/${zoneId}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getArea = async () => {
  try {
    const response = await API.get(`/area-filter`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getZonesWithSection = async () => {
  try {
    const response = await API.get("/zones-with-section");
    return response.data;
  } catch (error) {
    throw error;
  }
};
